// extracted by mini-css-extract-plugin
export default {"container":"LoadForm_container__KZNsf","wrapper":"LoadForm_wrapper__p0HrJ"};